import React, { useEffect, useState } from 'react';
import PageHeader from '../components/PageHeader';
import { getContentByCategory } from '../services/api';

export default function News() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    getContentByCategory('NEWS')
      .then((res) => setPosts(res.data))
      .catch(() => setPosts([]));
  }, []);

  return (
    <div>
      <PageHeader
        eyebrow="News & Announcements"
        title="Latest From The Organisation"
        subtitle="Outreach programmes, community visits, new initiatives and upcoming events."
      />
      <section className="section">
        <div className="container">
          {posts.length === 0 ? (
            <div className="card"><p>No announcements yet — check back soon.</p></div>
          ) : (
            <div className="grid grid-2">
              {posts.map((p) => (
                <div className="card" key={p.id}>
                  {p.imageUrl && (
                    <img
                      src={p.imageUrl}
                      alt={p.title}
                      style={{ width: '100%', height: 200, objectFit: 'cover', borderRadius: 4, marginBottom: 16 }}
                    />
                  )}
                  <h3>{p.title}</h3>
                  <p>{p.content}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
